<ng-container *ngIf="{
    row: columnData | async
  } as $">
  <span class="cursor-pointer" *ngIf="$.row" (click)="executeAction('edit',$.row)">{{getTrialType($.row)}}</span>
</ng-container>
